<template>
  <div class="md-layout">
    <audio ref="alert" loop>
      <source src="../../../assets/audio/alert.mp3" type="audio/mpeg" />
    </audio>
    <div class="md-layout-item md-size-100" id="map"></div>
  </div>
</template>
<script>
import { mapboxAccessToken } from "@/const.js";
import { EventBus } from "@/helpers";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

export default {
  data() {
    return {
      map: null,
      rpaMarkers: null,
      rpas: null,
      alert: false,
      latitude: 43.4723,
      longitude: -80.5449
    };
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    rpas: function(data) {
      console.log(data);
      var area = JSON.parse(data.area);
      var id = data.id;

      // create drone marker if it doesn't exist
      var rpa;
      var rpaMarker;
      if (!this.rpas.get(id)) {
        rpa = document.createElement("div");
        rpa.className = "rpaMarker";

        var popup = new mapboxgl.Popup().setHTML(
          `<div><p>Owner: <b>${data.user}</b></p><p>Email: <b>${data.email}</b></p><p>Phone: <b>${data.phone}</b></p><p>Manufacturer: <b>${data.drone.manufacturer}</b></p><p>Model: <b>${data.drone.model}</b></p><p>Registration No: <b>${data.drone.registrationnumber}</b></p><p><a href="https://www.google.com/maps/search/${data.lat},${data.lng}" target="_blank">Find My Drone</a></p></div>`
        );

        rpaMarker = new mapboxgl.Marker(rpa)
          .setLngLat([this.longitude, this.latitude])
          .setPopup(popup)
          .addTo(this.map);
        this.rpas.set(id, rpa);
        this.rpaMarkers.set(id, rpaMarker);
      } else {
        rpa = this.rpas.get(id);
        rpaMarker = this.rpaMarkers.get(id);
      }

      if (area.length > 0) {
        if (!this.alert) {
          this.alert = true;
          this.$refs.alert.play();
          this.map.flyTo({
            center: [data.lng, data.lat],
            zoom: 16
          });
          rpa.className = "rpaMarkerAlert";
          this.$notify({
            message: "Intrusion detected: " + area[0].properties.NAME,
            icon: "add_alert",
            horizontalAlign: "left",
            verticalAlign: "bottom",
            type: "danger",
            timeout: null
          });
        }
      } else {
        if (this.alert) {
          this.alert = false;
          this.$refs.alert.pause();
          rpa.className = "rpaMarker";
        }
      }
      rpaMarker.setLngLat([data.lng, data.lat]);
    }
  },
  computed: {},
  mounted() {
    this.rpas = new Map();
    this.rpaMarkers = new Map();

    this.$store.dispatch("drone/getAreas");

    EventBus.$on("gotAreas", () => {
      this.loadMap();
    });
  },
  beforeDestroy() {
    this.map.remove();
  },
  methods: {
    loadMap() {
      mapboxgl.accessToken = mapboxAccessToken;
      this.map = new mapboxgl.Map({
        container: "map",
        //style: "mapbox://styles/benying/cjx8b3cix1kz91co6bnxcy6o3",
        style: "mapbox://styles/mapbox/satellite-streets-v11",
        center: [this.longitude, this.latitude],
        zoom: 12
      });

      var draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });

      this.map.addControl(draw);
      var self = this;
      this.map.on("draw.create", function(e) {
        if (e.features.length > 0) {
          var data = e.features[0];
          data.properties.NAME = "University of Waterloo";
          console.log(data);
          self.$store.dispatch("drone/createArea", data);
        }
      });

      this.map.on("draw.update", function(e) {
        if (e.features.length > 0) {
          var data = e.features[0];
          console.log(data);
          self.$store.dispatch("drone/updateArea", data);
        }
      });

      this.map.on("draw.delete", function(e) {
        if (e.features.length > 0) {
          var data = e.features[0];
          console.log(data);
          self.$store.dispatch("drone/deleteArea", { id: data.id });
        }
      });

      var popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      });

      this.map.on("draw.selectionchange", function(e) {
        if (e.features.length > 0) {
          var data = e.features[0];
          console.log(data);

          popup
            .setLngLat(e.features[0].geometry.coordinates[0][0])
            .setHTML("<div><b>" + e.features[0].properties.NAME + "</b></div>")
            .addTo(this);
        } else {
          popup.remove();
        }
      });

      var hoveredAirspaceId = null;
      var hoveredAerodromeId = null;

      this.map.on("load", function() {
        this.addSource("airspaces", {
          type: "geojson",
          data: "https://dev.aimrobotics.io/airspaces_x.geojson"
        });

        this.addLayer({
          id: "fills",
          type: "fill",
          source: "airspaces",
          layout: {},
          paint: {
            "fill-color": [
              "match",
              ["get", "CLASS"],
              "A",
              "#e53935",
              "B",
              "#5e35b1",
              "C",
              "#039be5",
              "D",
              "#43a047",
              "E",
              "#fdd835",
              "F",
              "#6d4c41",
              "#546e7a"
            ],
            "fill-opacity": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              0,
              0.2
            ]
          }
        });

        this.addLayer({
          id: "borders",
          type: "line",
          source: "airspaces",
          layout: {},
          paint: {
            "line-color": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              "#FFFFFF",
              [
                "match",
                ["get", "CLASS"],
                "A",
                "#e53935",
                "B",
                "#5e35b1",
                "C",
                "#039be5",
                "D",
                "#43a047",
                "E",
                "#fdd835",
                "F",
                "#6d4c41",
                "#546e7a"
              ]
            ],
            "line-width": 2
          }
        });

        self.$store.state.drone.areas.forEach(area => {
          draw.add(area);
        });

        this.addSource("aerodromes", {
          type: "geojson",
          data: "https://dev.aimrobotics.io/aerodromes.geojson"
        });

        this.addLayer({
          id: "aerodromes_fills",
          type: "fill",
          source: "aerodromes",
          layout: {},
          paint: {
            "fill-color": [
              "match",
              ["get", "TYPE"],
              "AERODROME",
              "Red",
              "HELIPORT",
              "Orange",
              "WATERDROME",
              "Gold",
              "#546e7a"
            ],
            "fill-opacity": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              0,
              0.2
            ]
          }
        });

        this.addLayer({
          id: "aerodromes_borders",
          type: "line",
          source: "aerodromes",
          layout: {},
          paint: {
            "line-color": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              "#FFFFFF",
              [
                "match",
                ["get", "TYPE"],
                "AERODROME",
                "Red",
                "HELIPORT",
                "Orange",
                "WATERDROME",
                "Gold",
                "#546e7a"
              ]
            ],
            "line-width": 2
          }
        });

        this.setFilter("fills", ["in", "CLASS", "C", "D", "E", "F"]);
        this.setFilter("borders", ["in", "CLASS", "C", "D", "E", "F"]);

        var popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false
        });

        this.on("mousemove", "fills", function(e) {
          this.getCanvas().style.cursor = "pointer";

          if (e.features.length > 0) {
            if (hoveredAirspaceId) {
              this.setFeatureState(
                { source: "airspaces", id: hoveredAirspaceId },
                { hover: false }
              );
            }
            hoveredAirspaceId = e.features[0].id;
            this.setFeatureState(
              { source: "airspaces", id: hoveredAirspaceId },
              { hover: true }
            );
          }

          popup
            .setLngLat(e.lngLat)
            .setHTML(
              "<div><b>Name: " +
                e.features[0].properties.NAME +
                "</b></div>" +
                "<div>Class: " +
                e.features[0].properties.CLASS +
                "</div>" +
                "<div>Floor: " +
                e.features[0].properties.FLOOR +
                "</div>" +
                "<div>Ceiling: " +
                e.features[0].properties.CEILING +
                "</div>"
            )
            .addTo(this);
        });

        // Change it back to a pointer when it leaves.
        this.on("mouseleave", "fills", function() {
          this.getCanvas().style.cursor = "";

          if (hoveredAirspaceId) {
            this.setFeatureState(
              { source: "airspaces", id: hoveredAirspaceId },
              { hover: false }
            );
          }
          hoveredAirspaceId = null;

          popup.remove();
        });

        this.on("mousemove", "aerodromes_fills", function(e) {
          this.getCanvas().style.cursor = "pointer";

          if (e.features.length > 0) {
            if (hoveredAerodromeId) {
              this.setFeatureState(
                { source: "aerodromes", id: hoveredAerodromeId },
                { hover: false }
              );
            }
            hoveredAerodromeId = e.features[0].id;
            this.setFeatureState(
              { source: "aerodromes", id: hoveredAerodromeId },
              { hover: true }
            );
          }

          popup
            .setLngLat(e.lngLat)
            .setHTML(
              "<div><b>Name: " +
                e.features[0].properties.NAME +
                "</b></div>" +
                "<div>Type: " +
                e.features[0].properties.TYPE +
                "</div>" +
                "<div>Latitude: " +
                parseFloat(e.features[0].properties.LATITUDE).toFixed(4) +
                "N" +
                "</div>" +
                "<div>Longitude: " +
                -parseFloat(e.features[0].properties.LONGITUDE).toFixed(4) +
                "W" +
                "</div>"
            )
            .addTo(this);
        });

        this.on("mouseleave", "aerodromes_fills", function() {
          this.getCanvas().style.cursor = "";

          if (hoveredAerodromeId) {
            this.setFeatureState(
              { source: "aerodromes", id: hoveredAerodromeId },
              { hover: false }
            );
          }
          hoveredAerodromeId = null;

          popup.remove();
        });
      });
    }
  }
};
</script>
<style lang="css">
#map {
  width: 100%;
  height: 85vh;
  margin: 0px;
  padding: 0px;
}

.rpaMarker {
  background-image: url("../../../../public/img/rpa.png");
  background-size: cover;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.rpaMarkerAlert {
  background-image: url("../../../../public/img/rpa-alert.png");
  background-size: cover;
  width: 35px;
  height: 35px;
  cursor: pointer;

  -webkit-animation: blink 1s;
  -webkit-animation-iteration-count: infinite;
  -moz-animation: blink 1s;
  -moz-animation-iteration-count: infinite;
  -o-animation: blink 1s;
  -o-animation-iteration-count: infinite;
}
</style>
